import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { rightArrow, subMenuHome, subMenuPartners, subMenuProjects, whyUs } from '../../../assets/images';
import { useParams } from 'react-router-dom';


  const newsItems = [
    {
      id: 1,
      imgSrc: subMenuHome,
      title: 'İsitmə',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
    },
    {
      id: 2,
      imgSrc: subMenuPartners,
      title: 'Ventilyasiya',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
    },
    {
      id: 3,
      imgSrc: subMenuProjects,
      title: 'Soyutma, kondisionerləşdirmə',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
    },
    {
        id: 4,
        imgSrc: subMenuHome,
        title: 'Santexnika',
        description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
      {
        id: 5,
        imgSrc: subMenuPartners,
        title: 'Yanğınsöndürmə',
        description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
      {
        id: 6,
        imgSrc: subMenuProjects,
        title: 'Elektrik sistemləri',
        description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
      {
        id: 7,
        imgSrc: subMenuHome,
        title: 'Aşağı cərəyan',
         description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
      {
        id: 8,
        imgSrc: subMenuPartners,
        title: 'Avtomatlaşdırma sistemləri',
         description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
      {
        id: 9,
        imgSrc: subMenuProjects,
        title: 'Kanal sexi',
        description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
  ];
 
const SetemDetailItems = () => {


         const { t, i18n } = useTranslation();
         const currentLanguage = i18n.language; // Aktif dili alıyoruz

      const { id } = useParams();

      const [singleNews, setSingleNews] = useState("")

      useEffect(() => {


        const filteredTour = newsItems.find(product => product.id == id);
        setSingleNews(filteredTour);
    
      }, []);

  return (
    <div className='mt-[88px] md:mt-[104px] bg-[red]'>
       <div className='max-w-containerSm md:max-w-container mx-auto '>
        <div className='bg-[orange] text-[#1C1C1C]'>
        {singleNews.description}
        </div>
        <div className='flex justify-between bg-[brown] items-center mt-[72px]'>
      <p className='text-[#1C1C1C] font-medium text-[24px] mx-auto md:mx-0'>{t("Digər xidmətlər")}</p>
       <a className='hidden md:block' href={`/${currentLanguage}/setem`}>
                             <div className='flex justify-between items-center w-[144px] rounded-[12px] bg-[white] text-[#1C1C1C] h-[46px]'>
                                <p>{t("Hamısına bax")}</p>
                                <img className='w-2' src={rightArrow}></img>
                              </div>
                             </a>
        </div>
       <div className='grid grid-cols-1 md:grid-cols-3 gap-5 bg-[blue] mt-[32px]'>
        {newsItems.slice(0, 3).map((item) => (
        <div className='w-full md:w-[413px] border border-[#E5E5E5] rounded-lg'>
            <img src={item.imgSrc} className='w-full' alt='' />
            <div className='bg-[green] py-4 pl-4'>
            <p className='text-[#1C1C1C] text-[20px] font-medium'>{item.title}</p>
            <p className='mt-4 text-[#1C1C1C]'>{item.description.slice(0, 80)}..</p>
             <a href={`/${currentLanguage}/setem/${item?.id}`}>
                        <div className='flex items-center mt-4 justify-between mx-auto md:mx-0 min-w-[90px] rounded-[12px] bg-white text-[#1C1C1C] h-[46px]'>
                          <p>{t("Ətraflı")}</p>
                          <img className='w-2' src={rightArrow} />
                        </div>
                      </a>
            </div>
        </div>
            ))}


    </div>
       </div>
    </div>
  )
}

export default SetemDetailItems